const alertFollowUpHeader = [
  {
    group: 'Orçamento (Milhão)',
    columns: [
      {
        name: 'Id',
        id: 'orcamento-id',
        show: false
      },
      {
        name: 'Ano',
        id: 'orcamento-ano',
        show: true
      },
      {
        name: 'Empresa',
        id: 'orcamento-empresa',
        show: true
      },
      {
        name: 'Loja',
        id: 'orcamento-loja',
        show: true
      },
      {
        name: 'Fator Venda Bruta',
        id: 'orcamento-fator-venda',
        show: true
      },
      {
        name: 'DU Ano Passado/Atual',
        id: 'orcamento-du-passado',
        show: true
      },
      {
        name: 'Real + Proj. Ano Atual',
        id: 'orcamento-real-proj',
        show: true
      },
      {
        name: 'Diferença Ajustada%',
        id: 'orcamento-diferenca-ajustada',
        show: true
      },
      {
        name: 'Orçamento Final',
        id: 'orcamento-final',
        show: true
      }
    ]
  }
]

export default alertFollowUpHeader
